var _defs, _tspan, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "76.710793mm",
    height: "132.29167mm",
    viewBox: "0 0 76.710793 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(5.9709758e-7,-164.70834)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE08B",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(1.9097172,0,0,1.9097172,-24.542143,-74.367459)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 29.688359,175.58034 c 0,0.96213 -0.240531,1.20266 -0.601328,1.20266 -0.120265,0 -0.360796,-0.12027 -0.481062,-0.24053 -2.525575,-3.72823 -3.96876,-10.1023 -3.96876,-19.12221 0,-7.3362 1.563451,-11.78602 3.728229,-14.79266 0.120266,-0.24053 0.120266,-0.24053 0.240531,-0.24053 0.481062,0 1.08239,0.84186 1.08239,1.56345 z m 21.407254,-11.78601 c -0.360797,0 -0.962124,0.24053 -0.962124,1.68371 0,12.26708 -10.583362,15.15345 -13.589998,15.15345 -0.962124,0 -1.803983,-0.12026 -2.525575,-0.24053 -0.360797,-0.12026 -0.962124,-0.72159 -0.962124,-1.44318 v -38.12416 c 0,-0.72159 1.683716,-2.28504 2.405309,-2.40531 0.601328,-0.12026 1.202655,-0.12026 1.683717,-0.12026 4.810619,0 6.975397,2.28504 6.975397,3.24716 0,0.84186 -0.240531,2.16478 -1.683716,2.16478 -3.848495,0 -6.133539,4.08903 -6.133539,7.09567 0,5.41194 4.690353,7.09566 7.456459,7.09566 0,0 7.336194,-0.24053 7.336194,-8.29832 0,-12.50761 -14.552122,-13.59 -16.356105,-13.59 -0.24053,0 0,0.12027 -0.601327,0.12027 -0.601327,-0.12027 -1.082389,-1.80398 -1.082389,-2.28505 v -6.97539 c 0,-0.84186 -0.721593,-1.68372 -1.683717,-1.68372 -0.841858,0 -1.683716,0.84186 -1.683716,1.68372 v 6.01327 2.40531 c 0,0.72159 -0.962124,1.56345 -1.202655,1.56345 l -2.525575,0.96212 c -8.659114,3.72823 -13.108937,13.9508 -13.108937,23.09098 0,0.84185 0,1.80398 0.120266,2.64584 0.481062,5.17141 2.886371,9.98203 6.253805,13.95079 2.285043,2.76611 5.29168,4.69035 8.659114,5.53221 0.601327,0.24053 1.803982,1.56345 1.803982,2.40531 v 7.45646 c 0,0.84186 0.841858,1.56345 1.683716,1.56345 0.962124,0 1.683717,-0.72159 1.683717,-1.56345 v -7.69699 c 0,-0.48106 0.360796,-0.96212 1.082389,-1.32292 16.356104,-0.24053 18.881679,-15.27371 18.881679,-18.28035 0,-1.80398 -0.962124,-1.80398 -1.443185,-1.80398 z",
    id: "path184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsCut);
export default __webpack_public_path__ + "static/media/ts-cut.27471fb9384b1115147b7c9a984afbab.svg";
export { ForwardRef as ReactComponent };